import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { fetchListDone, fetchListError } from "../../state/events/actions";
import { ENDPOINTS_TAB, GET_CLIENT_EVENTS } from "../../state/events/constants";
import { bytesToBase64 } from "../../utils/util";

function* fetchEventList({ filters }) {
  try {
    const { clientId, tabName, geoLocation, locationAllowed } = filters;
    // tabName: "on-demand", "scheduled"
    const { endpoint } = ENDPOINTS_TAB.find((et) => et.tabName === tabName);
    const eventTypes = `${endpoint}-events`; // "ondemand", "scheduled"
    const url = GET_CLIENT_EVENTS.replace(":clientId", clientId).replace(
      ":eventTypes",
      eventTypes
    );
    const jsonStr = JSON.stringify({
      userLocation: geoLocation,
      locationAllowed
    });
    const encodedBytes = bytesToBase64(new TextEncoder().encode(jsonStr));
    const encodedComp = encodeURIComponent(encodedBytes);
    // Send Geo Location for geo restriction
    const result = yield call(Axios.core.get, url, {
      params: { ppv: true, location: encodedComp }
    });
    yield put(fetchListDone(result.data || [], tabName));
  } catch (e) {
    yield put(fetchListError(e));
  }
}

export default fetchEventList;
